import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import PaymentTableDocument from "./PaymentTableDocument";

// Preview écran : enveloppe le document pur dans un PDFViewer.
// Les lignes sont déjà calculées en amont (buildRecapRows) → aucun hook ici.
const PaymentTablePdf = ({ rows, title }) => (
  <PDFViewer style={{ width: "100%", height: "100%", border: 0 }}>
    <PaymentTableDocument rows={rows} title={title} />
  </PDFViewer>
);

export default PaymentTablePdf;
